import { render } from "./EnumControlRenderer.vue?vue&type=template&id=51a96c4b&ts=true"
import script from "./EnumControlRenderer.vue?vue&type=script&lang=ts"
export * from "./EnumControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__